import { Box, BoxProps, Flex } from '@chakra-ui/react';
import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

interface IOwnProps extends BoxProps {
  informationText: string;
  showIcon?: boolean;
}

const MessageForUser: React.FC<IOwnProps> = ({ informationText, showIcon = true, ...rest }) => {
  return (
    <Box
      bg="blue.50"
      borderWidth="1px"
      borderLeftWidth="4px"
      borderColor="blue.200"
      borderLeftColor="blue.400"
      borderRadius="md"
      p={5}
      {...rest}
    >
      <Flex flexDir={['column', 'column', 'column', 'row', 'row']} gap={3} align="flex-start">
        {showIcon && (
          <Box pt={1}>
            <FiAlertCircle color="#2c5282" size={30} />
          </Box>
        )}
        <Box
          flex={1}
          fontSize={['15px', '15px', '15px', '18px']}
          lineHeight={1.7}
          dangerouslySetInnerHTML={{ __html: informationText }}
          color="blue.700"
          sx={{
            '& p': { mb: '0.75em' },
            '& p:last-child': { mb: 0 },
            '& ul, & ol': { my: '0.75em', ms: '1.5em' },
            '& li + li': { mt: '0.25em' },
            '& strong, & b': { color: 'blue.800', fontWeight: 700 },
          }}
        />
      </Flex>
    </Box>
  );
};

export default MessageForUser;
